import api from './api';

export const getAll = async () => {
  try {
    const response = await api.get(`/roles/getAll`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los usuarios:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
